import { c as _c } from "react/compiler-runtime";
import { HospitalAddress, PartnerHospitalSummary } from "@/widgets/hospital/ui/organisms";
import { HospitalInfo } from "@/widgets/hospital/ui/molecules";
import { HospitalTagList, ImageSlide } from "@/widgets/hospital/ui/molecules";
import { PartnerHospitalOperation } from "@/entities/hospital/api/types";
import { HospitalInfoComponentProps } from "@/entities/hospital/model/types";
import { Spacer } from "@/shared/ui/atoms";
interface HospitalInfoContainerProps {
  hospitalInfo: HospitalInfoComponentProps;
  isPartner: boolean;
}
const HospitalInfoContainer = t0 => {
  const $ = _c(32);
  const {
    hospitalInfo,
    isPartner
  } = t0;
  const partnerHospitalOperation = hospitalInfo.partnerHospitalOperation as PartnerHospitalOperation | undefined;
  const {
    todaySchedule,
    weeklySchedules,
    location,
    tel,
    fullAddress
  } = hospitalInfo;
  const mainImages = partnerHospitalOperation?.mainImages;
  let t1;
  if ($[0] !== fullAddress || $[1] !== location || $[2] !== tel || $[3] !== todaySchedule || $[4] !== weeklySchedules) {
    t1 = {
      todaySchedule,
      weeklySchedules,
      tel,
      fullAddress,
      location
    };
    $[0] = fullAddress;
    $[1] = location;
    $[2] = tel;
    $[3] = todaySchedule;
    $[4] = weeklySchedules;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const addressProps = t1;
  let t2;
  if ($[6] !== todaySchedule) {
    t2 = () => {
      if (!todaySchedule) {
        return false;
      }
      const now = new Date();
      const [startTimeHour, startTimeMinute] = todaySchedule.startTime.split(":").map(Number);
      const [endTimeHour, endTimeMinute] = todaySchedule.endTime.split(":").map(Number);
      const startTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), startTimeHour, startTimeMinute, 0);
      const endTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), endTimeHour, endTimeMinute, 0);
      return now >= startTime && now <= endTime;
    };
    $[6] = todaySchedule;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const checkedIsOpen = t2;
  let t3;
  if ($[8] !== isPartner || $[9] !== mainImages) {
    t3 = isPartner && mainImages && mainImages.length > 0 && <ImageSlide images={mainImages} />;
    $[8] = isPartner;
    $[9] = mainImages;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== isPartner || $[12] !== partnerHospitalOperation) {
    t4 = isPartner && partnerHospitalOperation && <HospitalTagList tags={partnerHospitalOperation.tags} />;
    $[11] = isPartner;
    $[12] = partnerHospitalOperation;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== hospitalInfo) {
    t5 = <HospitalInfo hospitalInfo={hospitalInfo} isShowFullAddress={false} />;
    $[14] = hospitalInfo;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const t6 = checkedIsOpen();
  let t7;
  if ($[16] !== addressProps || $[17] !== t6) {
    t7 = <HospitalAddress addressProps={addressProps} initIsOpen={t6} />;
    $[16] = addressProps;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t5 || $[20] !== t7) {
    t8 = <div>{t5}{t7}</div>;
    $[19] = t5;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t4 || $[23] !== t8) {
    t9 = <div className="pt-4 px-4 pb-[30px] flex flex-col gap-5">{t4}{t8}</div>;
    $[22] = t4;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== isPartner || $[26] !== partnerHospitalOperation) {
    t10 = isPartner && partnerHospitalOperation && <><Spacer size={8} /><PartnerHospitalSummary partnerHospitalOperation={partnerHospitalOperation} /></>;
    $[25] = isPartner;
    $[26] = partnerHospitalOperation;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t3 || $[30] !== t9) {
    t11 = <div>{t3}{t9}{t10}</div>;
    $[28] = t10;
    $[29] = t3;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
};
export default HospitalInfoContainer;